import MaskedView from '@react-native-masked-view/masked-view';
import React from 'react';
import { GradientView, GradientViewProps } from './GradientView';
import { View } from 'react-native';


export const GradientFadingText = ({ gradient, style, children} : GradientViewProps) => {

  const mainElement = (withOpacity: boolean) => {
    return(
      <View style={[withOpacity && {opacity: 0}]}>
        {children}
      </View>);
  };
  return (
    <MaskedView maskElement={mainElement(false)} >
      <GradientView gradient={gradient} style={style}>
        {mainElement(true)}
      </GradientView>
    </MaskedView>
  );
};